import React, { useEffect } from 'react';
import {  BiTrash } from "react-icons/bi";
import { connect } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

import { deleteMyReview,   fetchMyReviews } from '../../redux/actions/review';


const MyReviewTable = ({dispatch, reviews}) => {

  const wallet= localStorage.getItem('wallet')

    const { addToast } = useToasts();

  
    useEffect(()=>{
        dispatch(fetchMyReviews(wallet))
       },[dispatch, wallet])

     

       const handleDelete = (id) => {
        dispatch(deleteMyReview(id, addToast))
       }


    return (
      <>
        <section className="author-area">
          <div className="container">
          

          <table className="table table-secondary table-hover table-responsive-lg">
  <thead>
    <tr className=''>
      
    
      <th scope="col">Image</th>
      <th scope="col">Project Name</th>
      <th scope="col">Review</th>
      <th scope="col">Rating</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody>
    {reviews && reviews.map(review=>(
        <tr key={review._id}>
            <td><img src={review.project.image} width={45} height={45} alt={review.project.projectname} /></td>
        <td>{review.project.projectname}</td>
        <td>{review.review.slice(0,70)}</td>
        <td>{review.rating}</td>
        <td className='table-action'>
          
          <span onClick={()=>handleDelete(review._id)} className='delete'><BiTrash/></span>
        </td>
      </tr>
    ))}
   
    
  </tbody>
</table>
{reviews.length<1 && <p className='text-danger'>No Review Found!</p> }
          </div>
        </section>

        
      </>
    );
};


function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      reviews: state.review.reviewData
    };
  }

export default connect(mapStateToProps)(MyReviewTable);
